export enum FormTabItemTypeEnum {
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  CHECKBOX = 'CHECKBOX',
  SELECT = 'SELECT',
  MULTISELECT = 'MULTISELECT',
  DATE = 'DATE',
  FILE = 'FILE',
  ID_NUMBER = 'ID_NUMBER',
  PHONE_NUMBER = 'PHONE_NUMBER',
  COUNTRY = 'COUNTRY',
}

export interface FormTabItem {
  id: number;
  title: string;
  description: string;
  type: FormTabItemTypeEnum;
  typeData: any[];
  typeDataParameterId: number | null;
  isMandatory: boolean;
  isActive: boolean;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  sort: number;
  defaultAnswer: string;
  typeDataParameter: any;
  answerValue?: any;
  dropdownOptions:any[];
}

export interface FormTab {
  id: number;
  title: string;
  description: string;
  isActive: boolean;
  icon: string;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  sort: number;
  formTabItems: FormTabItem[];
  filteredFormTabItems: FormTabItem[];
  isTabCompleted:boolean|null
}

export interface FormAnswer {
  tabId: number;
  itemId: number;
  answer: any;
}
